import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628ef268"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mobile-nav"
}
const _hoisted_2 = { class: "dropdown-container" }
const _hoisted_3 = { class: "d-flex flex-row" }

import { createApp, nextTick, onMounted, onUnmounted, ref } from "vue";
import CasesIntroduction from "@/components/rules/CasesIntroduction.vue";
import Rule1Nimetav from "@/components/rules/Rule1Nimetav.vue";
import Rule2Omastavtav from "@/components/rules/Rule2Omastav.vue";
import Rule3Osastav from "@/components/rules/Rule3Osastav.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RulesView',
  setup(__props) {

const rules = [
  { component: CasesIntroduction },
  { component: Rule1Nimetav },
  { component: Rule2Omastavtav },
  { component: Rule3Osastav },
];
const tab = ref(0);
const tabHeadings = ref<string[]>([]);
const overlayVisible = ref(false);
const isLargeScreen = ref(window.innerWidth >= 1200);

function updateScreenSize() {
  isLargeScreen.value = window.innerWidth >= 1200;
}

// Extract <h1> content from each component
async function getHeadings() {
  tabHeadings.value = [];

  for (const rule of rules) {
    const wrapper = document.createElement("div");
    const app = createApp(rule.component);
    app.mount(wrapper);

    // Wait for rendering and extract the <h1> content
    await nextTick(); // Ensure DOM updates
    const heading =
      wrapper.querySelector("h1")?.innerText?.trim() || "Untitled Rule";
    tabHeadings.value.push(heading);

    // Clean up
    app.unmount();
    wrapper.remove();
  }
}

function toggleOverlay() {
  overlayVisible.value = !overlayVisible.value;
}

function selectRule(index: number) {
  tab.value = index; //Update the active tab
  overlayVisible.value = false; // Close the overlay
}

onMounted(() => {
  getHeadings();
  if (typeof window !== "undefined") {
    window.addEventListener("resize", updateScreenSize);
  }
});

onUnmounted(() => {
  if (typeof window !== "undefined") {
    window.removeEventListener("resize", updateScreenSize);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_responsive, null, {
        default: _withCtx(() => [
          (!isLargeScreen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    onClick: toggleOverlay,
                    ref: "dropdownBtn",
                    class: "dropdown-trigger",
                    variant: "flat",
                    color: "#dcdefb",
                    "aria-expanded": overlayVisible.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-chevron-double-down")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["aria-expanded"]),
                  _createVNode(_component_v_overlay, {
                    modelValue: overlayVisible.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((overlayVisible).value = $event)),
                    "location-strategy": "connected",
                    location: "bottom",
                    scrim: true,
                    attach: '.dropdown-trigger',
                    "scroll-strategy": "none",
                    class: "overlay-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "dropdown-overlay" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabHeadings.value, (heading, index) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: index,
                                  onClick: _withModifiers(($event: any) => (selectRule(index)), ["stop"]),
                                  class: "dropdown-item",
                                  active: tab.value === index,
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(heading), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "active"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "attach"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, { class: "main-content rules-card" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (isLargeScreen.value)
                  ? (_openBlock(), _createBlock(_component_v_tabs, {
                      key: 0,
                      modelValue: tab.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
                      direction: "vertical",
                      class: "tabs-container"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabHeadings.value, (heading, index) => {
                          return (_openBlock(), _createBlock(_component_v_tab, {
                            key: index,
                            value: index
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(heading), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_tabs_window, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
                  class: "content-area"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rules, (rule, index) => {
                      return _createVNode(_component_v_tabs_window_item, {
                        key: index,
                        value: index
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            flat: "",
                            class: "rules-inner-card"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(rule.component)))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})